import { Variable } from 'vev';
import { useGlobalStore } from './use-store';

export function useVariable(variableKey?: string): Variable | undefined {
  return useGlobalStore((s) => s.variables).find((variable) => variable.key === variableKey);
}
